const getEmbedUrl = (url) => {
	try {
		const parsed = new URL(url);

		if (parsed.hostname.includes('youtube.com') || parsed.hostname.includes('youtu.be')) {
			let videoId = '';
			if (parsed.hostname.includes('youtu.be')) {
				videoId = parsed.pathname.slice(1);
			} else {
				videoId = parsed.searchParams.get('v');
			}
			if (!videoId) return url;
			return `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
		}

		if (parsed.hostname.includes('vimeo.com')) {
			const videoId = parsed.pathname.split('/').filter(Boolean).pop();
			if (!videoId) return url;
			return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
		}

		return url;
	} catch {
		return url;
	}
};

const handleOpen = (figure) => {
	const videoUrl = figure.dataset.videoPopup;
	if (!videoUrl) return;

	const dialog = document.createElement('dialog');
	dialog.className = 'video-popup-dialog';
	dialog.setAttribute('aria-label', 'Video popup');

	const closeBtn = document.createElement('button');
	closeBtn.className = 'video-popup-dialog__close';
	closeBtn.setAttribute('aria-label', 'Close video');
	closeBtn.type = 'button';

	const iframe = document.createElement('iframe');
	iframe.className = 'video-popup-dialog__iframe';
	iframe.src = getEmbedUrl(videoUrl);
	iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
	iframe.setAttribute('allowfullscreen', '');
	iframe.setAttribute('frameborder', '0');
	iframe.title = 'Video';

	dialog.appendChild(closeBtn);
	dialog.appendChild(iframe);
	document.body.appendChild(dialog);

	const handleClose = async () => {
		dialog.close();
		document.body.style.overflow = '';
		await new Promise((resolve) => setTimeout(resolve, 300));
		dialog.remove();
	};

	closeBtn.addEventListener('click', handleClose);
	dialog.addEventListener('click', (e) => {
		if (e.target === dialog) handleClose();
	});

	dialog.showModal();
	document.body.style.overflow = 'hidden';
};

const videoPopup = () => {
	const figures = document.querySelectorAll('[data-video-popup]');
	if (!figures.length) return;

	figures.forEach((figure) => {
		figure.style.cursor = 'pointer';
		figure.setAttribute('role', 'button');
		figure.setAttribute('tabindex', '0');
		figure.setAttribute('aria-label', 'Play video');

		figure.addEventListener('click', () => handleOpen(figure));
		figure.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				handleOpen(figure);
			}
		});
	});
};

export { videoPopup };
